module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/evt-step3-27bcac2a2f24e3e509036c17117b4453.svg";